/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_SubInputs */

const en_pc_rv_sub = /** @type {(inputs: Pc_Rv_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A summary of what early testers and reviewers report after real editing sessions with the alpha builds.`)
};

const zh_pc_rv_sub = /** @type {(inputs: Pc_Rv_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汇总了早期测试者和评测者用 Alpha 版本实际修图后的反馈。`)
};

/**
* | output |
* | --- |
* | "A summary of what early testers and reviewers report after real editing sessions with the alpha builds." |
*
* @param {Pc_Rv_SubInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_sub = /** @type {((inputs?: Pc_Rv_SubInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_SubInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_sub(inputs)
	return zh_pc_rv_sub(inputs)
});
export { pc_rv_sub as "pc.rv.sub" }